'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (
          !desc ||
          ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)
        ) {
          desc = {
            enumerable: true,
            get: function () {
              return m[k];
            },
          };
        }
        Object.defineProperty(o, k2, desc);
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', { enumerable: true, value: v });
      }
    : function (o, v) {
        o['default'] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = __importStar(require('react'));
const form_1 = require('../contexts/form');
const useStatusHandler_1 = __importDefault(
  require('../hooks/useStatusHandler')
);
const useSubmitHandler_1 = __importDefault(
  require('../hooks/useSubmitHandler')
);
function BasicForm(props) {
  const {
      autoSave,
      children,
      defaultData,
      formDataType = 'object',
      onSubmit,
      onSuccess,
    } = props,
    extraProps = __rest(props, [
      'autoSave',
      'children',
      'defaultData',
      'formDataType',
      'onSubmit',
      'onSuccess',
    ]);
  const onSubmitHandler = (0, useSubmitHandler_1.default)({
    autoSave,
    formDataType,
    onSubmit,
    onSuccess,
  });
  const changeStatus = (0, useStatusHandler_1.default)();
  const { changedData, status } = (0, form_1.useInternalForm)();
  const timeout = (0, react_1.useRef)(undefined);
  const form = (0, react_1.useRef)(null);
  // if there is a change, update the status
  (0, react_1.useEffect)(() => {
    // when data changes, change the status to changed
    if (Object.keys(changedData).length) {
      if (status === 'WAITING') changeStatus('CHANGED');
      if (autoSave) {
        if (timeout.current) clearTimeout(timeout.current);
        const target = form.current;
        timeout.current = setTimeout(() => {
          onSubmitHandler({
            target,
          });
        }, autoSave);
      }
    }
  }, [changedData, onSubmitHandler]);
  return react_1.default.createElement(
    'form',
    Object.assign({}, extraProps, {
      noValidate: true,
      onSubmit: onSubmitHandler,
      ref: form,
    }),
    children
  );
}
exports.default = BasicForm;
//# sourceMappingURL=BasicForm.js.map
